import { Injectable } from '@angular/core';
import { RegionService } from '@parashift/shared/services';

@Injectable({
  providedIn: 'root'
})
export class LocalRegionService extends RegionService {}
